<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :title="$t('merchantAccount.cash_out')" width="736px" class="diglog-card" :close-on-click-modal="false" @close="handleDialogClose">
      <div class="diglog-container">
        <div class="section-title">
          {{ $t('data.amount_details') }}
        </div>
        <div class="section-tip">
          {{ $t('tips.cash_out_amount_enter') }}
          <div class="line-bottom-1px" />
        </div>

        <el-form ref="withdrawForm" :model="withdrawForm" label-width="200px" :rules="mfcRules" status-icon label-position="left">
          <el-row>
            <el-col>
              <el-form-item
                :label="$t('components.amount')"
                prop="withdraw_money"
              >
                <template slot="label">
                  <span>{{ $t('data.cash_out_amount') }} <span v-if="isCurCountryID" style="font-size: 10px;">({{ $t('data.cash_out_amount_should') }} ≥ {{ withdrawSettings.withdraw_threshold | toDivideWithDot }})</span></span>
                </template>
                <el-input v-model="withdrawForm.withdraw_money" placeholder="Enter amount" type="text" class="input-item" autocomplete="off">
                  <template slot="prepend">{{ $store.getters.currency }}</template>
                </el-input>
              </el-form-item>
            </el-col>
<!--            <div v-if="$store.getters.curCountry.country_code === 'PH'" class="section-tip">-->
<!--              <template v-if="withdrawForm.withdraw_money>0">-->
<!--                <span v-if="withdrawForm.withdraw_money<=50000">{{ $t('tips.withdraw_tip_less') }}</span>-->
<!--                <template v-if="withdrawForm.withdraw_money>50000">-->
<!--                  <span>{{ $t('tips.withdraw_tip_more') }}</span>-->
<!--                </template>-->

<!--              </template>-->
<!--              <template v-else>-->
<!--                <span>{{ $t('tips.withdraw_tip_less') }}; {{ $t('tips.withdraw_tip_more') }} </span>-->
<!--              </template>-->

<!--            </div>-->
            <el-col>
              <el-form-item>
                <div slot="label">
                  <span>{{ $t('tips.dashboard_balance_number') }}</span>
                  <el-tooltip placement="top">
                    <div slot="content" style="width: 300px">
                      <span>{{ $t('tips.dashboard_balance_question') }}</span>
                    </div>
                    <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
                  </el-tooltip>
                </div>

                <div class="input-show-info" style="display: block;">{{ $store.getters.currency }}  {{ balanceInfo.available_withdraw | toDivide100 }}</div>

              </el-form-item>
            </el-col>
            <!-- <el-col  :offset="2">
              <el-form-item>
                <div slot="label">
                  <span>{{ $t('tips.dashboard_balance_number') }}</span>
                  <el-tooltip placement="top">
                    <div slot="content" style="width: 300px">
                      <span>{{ $t('tips.dashboard_balance_question') }}</span>
                    </div>
                    <span> <svg-icon icon-class="icon-font-question" class="icon-question"/></span>
                  </el-tooltip>
                </div>

                <div class="input-show-info" style="display: block;">{{ $store.getters.currency }}  {{ balanceInfo.available_withdraw | toDivide100 }}</div>

              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row v-if="withdraw_fee_status===1">
            <el-col :span="24">
              <el-form-item>
                <div slot="label">
                  <span>{{ $t('dashboard.fee') }}</span>
                  <el-tooltip placement="top">
                    <div slot="content" style="width: auto">
                      <span>{{ $t('tips.fee_tip') }}</span>
                    </div>
                    <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
                  </el-tooltip>
                </div>
                <div class="fee-wrapper">
                  <div class="currency-prepend">{{ selectedAccountCurrency }}</div>
                  <div class="fee-value">{{ formattedWithdrawFee }}</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="section-title mt-24">
            {{ $t('data.bank_details') }}
          </div>
          <div class="section-tip">
            {{ $t('tips.cash_out_account') }}
            <div class="line-bottom-1px" />
          </div>
          <!-- <div class="detail-table">
            <div class="detail-header">
              <div class="detail-th">{{ $t('merchant.account_name') }}</div>
              <div class="detail-th">{{ $t('merchant.account_bank') }}</div>
              <div class="detail-th" style="min-width: 250px">{{ $t('merchant.account_num') }}</div>
            </div>
            <div class="detail-content">
              <div class="detail-td">{{ merchantInfo.settlement_bank_account_name }}</div>
              <div class="detail-td">{{ merchantInfo.settlement_bank }}</div>
              <div class="detail-td" style="min-width: 250px">{{ merchantInfo.settlement_bank_account_num }}</div>
            </div>
          </div>-->
          <el-row>
            <el-col :span="24">
              <el-form-item
                :label="$t('data.account')"
                prop="bank_no"
              >
                <template slot="label">
                  <span>{{ $t('data.account') }}</span>
                </template>
                <div class="account-wrapper">
                  <div class="currency-prepend">{{ selectedAccountCurrency }}</div>
                  <el-select
                    v-model="withdrawForm.bank_no"
                    class="account-select"
                    :placeholder="$t('data.account')"
                    clearable
                  >
                    <el-option
                      v-for="(item,index) in accountList"
                      :key="index"
                      :label="item.settlement_bank + '-' + item.settlement_bank_account_num"
                      :value="item.bank_no"
                    />
                  </el-select>
                </div>
                <div v-if="accountList.length === 0" class="account-empty-tip">
                  <span style="color: #71110e;font-size: 12px;">
                    {{ $t('tips.not_bank_account') }}
                  </span>
                  <span style="color: #3855f1;cursor: pointer;font-size: 12px;padding-left: 10px;" @click="$router.push({name:'Financial_Manage_Setting'})">Go to Add</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="$store.getters.isOpenMfa">
            <el-col :span="24">
              <el-form-item
                :label="$t('system.mfa_verify_code')"
                prop="verification_code"
                style="margin-top: 30px"
              >
                <el-input v-model="withdrawForm.verification_code" maxlength="6" placeholder="Enter your MFA verification code" autocomplete="off" clearable />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn('form')">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
    <WithdrawSuccessModal ref="withdrawSuccessModal" />
  </div>
</template>

<script>
import { bankQueryList, mchWithdraw } from '@/api/merchant-manage/merchant-manage.js'
import serviceConst from '@/const/serviceConst.json'
import { fetchWithdrawFee, fetchWithdrawType } from '@/api/system/system.js'
// import { GetBankList } from '@/api/data/data'
import WithdrawSuccessModal from './WithdrawSuccessModal.vue'

export default {
  name: 'Withdraw_Modal',
  components: {
    WithdrawSuccessModal
  },
  props: {
    merchantInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    balanceInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    withdrawThreshold: {
      type: Number,
      default: 0
    }
  },
  data() {
    this.AUTO_WITHDRAW_TYPE = {
      period: 1,
      fixedAmount: 2
    }
    this.WITHDRAW_TYPE = {
      manually: 1,
      automatic: 2
    }
    this.checkAmount = (rule, value, callback) => {
      const toDivideWithDot = this.$options.filters['toDivideWithDot']
      const toDivide100 = this.$options.filters['toDivide100']
      const toThousandFilter = this.$options.filters['toThousandFilter']
      const availableWithdraw = this.$commonFn.mathDivide(Number(this.balanceInfo.available_withdraw), 100)
      value = Number(value)
      this.$commonFn.validateFormAmount({ rule, value, callback })
      if (value > 10000000000) {
        return callback(new Error('Currently up to 100 billion'))
      }
      if (value <= 0 || isNaN(value)) {
        return callback(new Error('Please enter a non-negative number'))
      }
      if (!/^(0|[1-9]\d*)(.\d{1,2})?$/.test(value)) {
        return callback(new Error('Please enter two decimal places'))
      }
      if (value > availableWithdraw) {
        return callback(new Error('Insufficient balance!'))
      }
      if (this.withdrawThreshold && value < this.withdrawThreshold) {
        return callback(new Error(`Cashout Threshold: ${toThousandFilter(this.withdrawThreshold)}${this.$store.getters.currency}`))
      }
      if (this.isCurCountryID) {
        if (value < toDivide100(this.withdrawSettings.withdraw_threshold)) {
          return callback(new Error('Cash Out Amount should be greater than or equal to ' + toDivideWithDot(this.withdrawSettings.withdraw_threshold)))
        }
      }
      // 本币提现时，提现金额必须大于服务费
      const selectedAccount = this.accountList.find(item => item.bank_no === this.withdrawForm.bank_no)
      if (selectedAccount && selectedAccount.settlement_type === 1 && this.withdraw_fee) {
        const serviceFee = toDivide100(this.withdraw_fee)
        if (value <= serviceFee) {
          return callback(new Error(`Amount greater than ${toDivideWithDot(this.withdraw_fee)} ${this.$store.getters.currency}`))
        }
      }
      callback()
    }
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length !== 6 || !/^\d+$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    return {
      withdrawForm: { withdraw_money: '', verification_code: '', bank_no: undefined },
      mfcRules: {
        bank_no: [
          { required: true, message: 'Account cannot be empty', trigger: ['blur', 'change'] }
        ],
        verification_code: [
          { required: true, message: 'MFA Verification Code cannot be empty', trigger: 'blur' },
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ],
        withdraw_money: [
          { required: true, message: 'Amount cannot be empty', trigger: 'blur' },
          { validator: this.checkAmount, trigger: 'blur' }
        ]
      },
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      accountList: [],
      withdraw_fee: null,
      usd_withdraw_fee: null,
      withdraw_fee_status: null,
      withdrawSettings: {}
    }
  },
  computed: {
    isCurCountryID() {
      return this.$store.getters.curCountry.country_code === 'ID'
    },
    // 选中账户的币种
    selectedAccountCurrency() {
      const selectedAccount = this.accountList.find(item => item.bank_no === this.withdrawForm.bank_no)
      if (selectedAccount) {
        return selectedAccount.settlement_type === 1 ? this.$store.getters.currency : 'USD'
      }
      return this.$store.getters.currency
    },
    // 当前提现服务费（根据账户类型动态返回）
    currentWithdrawFee() {
      const selectedAccount = this.accountList.find(item => item.bank_no === this.withdrawForm.bank_no)
      // 提现币种
      const withdrawCurrency = this.$store.getters.currency
      // 银行卡币种（settlement_type: 1-本币, 2-USD）
      const bankCurrency = selectedAccount && selectedAccount.settlement_type === 2 ? 'USD' : withdrawCurrency
      // 当提现币种和银行卡币种不同，且银行卡币种为USD时，使用usd_withdraw_fee
      if (selectedAccount && withdrawCurrency !== bankCurrency && bankCurrency === 'USD') {
        return this.usd_withdraw_fee
      }
      return this.withdraw_fee
    },
    // 格式化后的服务费
    formattedWithdrawFee() {
      const toDivideWithDot = this.$options.filters['toDivideWithDot']
      return toDivideWithDot ? toDivideWithDot(this.currentWithdrawFee) : this.currentWithdrawFee
    }
  },
  created() {
    this.getWithdrawFee()
    this.getBankQueryList()
    // this.getAccountList()
    if (this.isCurCountryID) {
      this.getWithdrawType()
    }
  },
  methods: {
    getWithdrawType() {
      fetchWithdrawType().then(res => {
        const { data } = res || {}
        this.withdrawSettings = data
      })
    },
    getBankQueryList() {
      // 获取所有可用账户（包括本币和美元账户）
      bankQueryList({ audit_status: 2, use_status: 1 }).then(res => {
        const data = res.data || []
        this.accountList = data.filter(i => i.audit_status === 2)
        // 默认第一个
        this.withdrawForm.bank_no = this.accountList[0] && this.accountList[0].bank_no
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogVisible = value
    },
    onClickSubmitBtn() {
      this.$refs.withdrawForm.validate((valid) => {
        if (valid) {
          this.submiting = true
          const { withdraw_money, verification_code, bank_no } = this.withdrawForm
          const params = {
            amount: this.$commonFn.mathMultiply(Number(withdraw_money), 100),
            mfa_code: verification_code,
            bank_no: bank_no,
            timestamp: Date.now()
          }
          const paramsData = {}
          const aesKey = this.$commonFn.generateRandomString()
          const aesIV = this.$commonFn.generateRandomString()
          const aesKeyIv = JSON.stringify({ key: aesKey, iv: aesIV })
          paramsData.key = this.$commonFn.rsaEncrypt(aesKeyIv)
          paramsData.param = this.$commonFn.cryptoJSAesEncrypt(JSON.stringify(params), aesKey, aesIV)
          paramsData.sign = this.$commonFn.rsaSign(JSON.stringify(params))
          mchWithdraw(paramsData).then(res => {
            if (res.code === serviceConst.resCode.succ) {
              this.changModalStatus(false)
              this.$emit('get-merchant-info')
              const obj = JSON.parse(JSON.stringify(params))
              this.withdrawForm.withdraw_money = ''
              setTimeout(() => {
                this.$refs.withdrawSuccessModal.changModalStatus(true, obj.amount / 100)
              }, 500)
            }
          }).finally(() => {
            this.submiting = false
          })
        }
      })
    },
    getWithdrawFee() {
      fetchWithdrawFee().then(res => {
        const { usd_withdraw_fee, withdraw_fee, withdraw_fee_status } = res.data
        this.withdraw_fee = withdraw_fee
        this.usd_withdraw_fee = usd_withdraw_fee
        this.withdraw_fee_status = withdraw_fee_status
      })
    },
    handleDialogClose() {
      this.withdrawForm = {}
      this.$nextTick(function() {
        this.$refs['withdrawForm'].clearValidate()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.detail-header{
  border: 1px solid #D3D7DF;
  border-radius: 4px;
}
.detail-header,.detail-content{
 display: flex;
}
.detail-th:not(:last-child){
  border-right: 1px solid #D3D7DF;
}
.detail-th{
  padding: 10px;
  font-weight: 500;  font-family: 'Poppins-Medium';
  font-size: 16px;
  line-height: 1.2;
  color: #14294F;
}
.detail-td{
  padding: 20px 10px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  color: #4B5567;
}
.detail-th,.detail-td{
  flex: 1;
}

.tip{
  padding: 0;
  margin:0;
  margin-top: -18px;
  font-size: 14px;
  font-weight: 400;
  color: #303133;
  text-align: right;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 100%;
  margin-top: 50px;
  height: 40px;
  border-radius: 4px;
}
.icon-question{
  margin-left: 4px;
  font-size: 11px;
  position: relative;
  top: -2px;
  cursor: pointer;
}
.currency-prepend {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-right: none;
  border-radius: 4px 0 0 4px;
  color: #488CE8;
  font-size: 14px;
  white-space: nowrap;
  min-width: 60px;
}
.account-empty-tip {
  margin-top: 8px;
  font-size: 12px;
}
.fee-wrapper {
  display: flex;
  align-items: stretch;
}
.fee-value {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background-color: #F5F7FA;
  border: 1px solid #DCDFE6;
  border-radius: 0 4px 4px 0;
  color: #606266;
  font-size: 14px;
  min-height: 32px;
}
.account-wrapper {
  display: flex;
  align-items: stretch;
}
.account-select {
  flex: 1;
  ::v-deep .el-input__inner {
    height: 38px;
    line-height: 38px;
    border-radius: 0 4px 4px 0;
  }
  ::v-deep .el-input {
    width: 100%;
  }
}

</style>
